<div class="header wh-100-background w-100">
  <div class="d-flex flex-column">
    <div class="header-row d-flex flex-row align-items-center justify-content-between"
      [ngClass]="isMobile ? 'psic-px-7 psic-py-2 psic-gap-2' : 'psic-py-1'">
      <!-- Mobile View -->
      @if (isMobile) {
        <div class="d-flex flex-row align-items-center justify-content-between w-100">
          <div class="d-flex flex-row align-items-center">
            <!-- PSIC logo section Mobile -->
            <div class="logo-container d-flex align-items-center mx-auto">
              <img src="../../../../assets/images/logo-mini.svg" alt="psic-logo-mini" />
            </div>
          </div>
          <!-- section for url not containing "dashboard" text -->
          <div class="customer-care-container d-flex flex-row align-items-center">
            <!-- Customer Care icon -->
            <div class="d-flex psic-p-2">
                        <mat-icon psicTooltipPlacement="bottom" psicTooltip="<div class='d-flex flex-column align-items-end'><p class='disclaimer'>Need help? Call us</p><p class='disclaimer-bold text-right'>
                                <strong><a href='#'>800 303 5000</a></strong></p></div>"
                            class="d-flex mat-icon-32 p1-50-color" [svgIcon]="'phone'"></mat-icon>
          </div>
        </div>
      </div>
    }

    <!-- Desktop View -->
    @if (!isMobile) {
      <div
        class="d-flex flex-row w-100 align-items-center justify-content-between psic-gap-9 psic-px-8 psic-px-4"
        style="height: 40px; width: 40px;">
        <div class="d-flex flex-row psic-gap-6">
          <!-- PSIC logo section Desktop -->
          <div class="logo-container d-flex align-items-center" style="height: 33.84px; width: 198.03px;">
            <img src="../../../../assets/images/psic_logo.svg" alt="psic-logo-img" />
          </div>
        </div>
        <!-- Desktop - Profile section -->
        <div class="d-flex align-items-center psic-gap-8">
          <!-- theme dropdown -->
          @if (!isProduction) {
            <select class="psic-br-4 psic-p-2" (change)="onThemeChange($event)" [(ngModel)]="defaultTheme">
              @for (theme of themes; track theme) {
                <option [value]="theme.value">{{ theme.label }}</option>
              }
            </select>
          }
          <!-- Desktop - Need help section -->
          <div class="customer-care-container">
            <div class="d-flex flex-row psic-gap-8">
              <!-- Customer Care icon -->
              <div class="d-flex flex-row align-items-center psic-gap-2">
                <div id="contact-text" class="d-flex flex-column align-items-center justify-center">
                  <p class="top">Need help? Call us</p>
                  <p class="bottom"><strong>800 303 5000</strong></p>
                </div>
                <mat-icon [svgIcon]="'phone'" class="d-flex mat-icon-24 dg_mg-60-color"></mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    <!--End Desktop-->
  </div>
</div>
</div>
